import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Game content is static for this build — the old theme content editor
 * (word puzzle / unscramble / quiz tabs) was removed. Keep the route so
 * bookmarks and the rules "Continue" link do not 404.
 */
function ThemeUpdate() {
  return <Navigate to="/admin" replace />;
}

export default ThemeUpdate;
